<template>
    <div class="FristView publicViewClass" style="padding-top:0">
        <div class="edit-step" v-if="!importTopic">
            <topicSteps :active = "1" :propList="propList"></topicSteps>
        </div>
        <div class="importTopic" v-if="!importTopic">
            <el-upload 
            accept=".xls,.xlsx" drag  
            :limit="1"  
            :auto-upload="true" 
             :action="$config.baseUrl + '/platform/question/importExcel'" 
              :headers="headers"
             :on-success="handleSuccess"
              ref="upload"  
              >
                <i class="icon-al-file-fill"></i>
                <div class="el-upload__text">
                   请将文件拖拽到此区域上传试题，或<em>选择文件上传试题</em>
                </div>
                 <div class="el-upload__tip" slot="tip">仅支持excel文件</div>
               <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
            <div class="template-text" @click="openExcel">
                <div class="excel-icon"></div>
                下载Excel导题模版
            </div>
            <div class="tips-text">
                <div class="title">导入说明</div>
                <p style="margin-top:17px">
                    1.支持导入题型：单选题，多选题，判断题，填空题，问答题，不定项选择题，排序题 <span style="color:red;font-size:14px">（暂不支持完形填空题型，请手动增加该题型）</span>。
                </p>
                <p>2.建议按多次分批导入，导入前建议试题编好分类，方便题库管理。</p>
                <p>3.推荐使用微软Office编辑</p>
            </div>
        </div>
         <div class="edit-step" v-if="importTopic">
            <topicSteps :active = "2" :propList="propList"></topicSteps>
        </div>
        <div class="app-inner show_container" style="padding:16px 0 !important;margin-bottom:80px"  v-if="importTopic">
           <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="cacelIM">
                取消导入
            </div>
           <el-button type="primary"  class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openTwoSteps"
            >
             检查完毕下一步
           </el-button>
            </div>
        <div class="question-duplication-container staff_manage_center">
             <div class="public-list-container">
                 <div class="public-list-container-table">
                    <div class="public-list-container-table-header flex align-cen">
                            <div class="stclass pustclass">排序</div>
                            <div class="stsort pustclass">题目标题</div>
                            <div class="stcz pustclass">题型</div>
                            <div class="stcz1 pustclass">分数</div>
                            <div class="stcz2 pustclass"></div>
                        </div>
                     <div v-if="itemList.length">
                        <div class="public-list-container-table-row"
                        v-for="(item,index) in itemList"
                        >
                         <div class="flex align-cen" :class="item.isTrue ? 'pdd' : ''">
                          <div class="stclass pustclass">
                            {{index+1}}
                          </div>
                          <div class="stsort pustclass">
                            <p v-html="item.title"></p>
                          </div>
                           <div class="stcz pustclass">
                            {{$util.getTopicType(item.type)}}
                           </div>
                           <div class="stcz1 pustclass" style="color:red">
                            {{item.score}}
                           </div>
                           <div class="stcz2 pustclass" style="color:red;cursor: pointer;" @click="openTopicRe(item.isTrue,index,item)">
                                {{item.isTrue ? '收回' : '展开查看' }}
                           </div>
                           </div>
                           <div class="topicIstru" v-if="item.isTrue">
                            <div class="duplicate-questions flex">
                                 <div class="duplicate-question">
                                 <div class="portlet">
                                            <div class="portlet-head flex align-cen">
                                                <!-- <div class="caption">试题{{index+1}}</div> -->
                                                <div class="btn-set mft flex align-cen">
                                                   <div class="btn-blue-delete" @click="deletTopic(index)">删除</div>
                                                    <div class="btn-default" @click="editTopic(item,index)">编辑</div>
                                                </div>
                                            </div>
                                            <div class="portlet-body">
                                                <div class="duplication-info-container">
                                                    <div class="ques-title flex align-cen">
                                                        <span class="ques-type">
                                                             {{$util.getTopicType(item.type)}}
                                                        </span>
                                                        <div class="qcotent">
                                                            <p v-html="item.title"></p>
                                                        </div>
                                                        <div class="ques-score">
                                                            ({{item.score}}分)
                                                        </div>
                                                    </div>
                                                    <div class="question-option-list">
                                                        <ol  v-if="item.type != 9 && item.type != 5">
                                                            <li v-for="(sonitem,sonIndex) in item.answerList">
                                                               <p v-html="sonitem.content"></p>
                                                            </li>
                                                        </ol>
                                                     <div class="refAnswer" style="margin-left:-25px" v-if="item.type == 5">
                                                <div class="detailKeyWorld" v-if="item.rule">
                                                    <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                                    <p>关键字：</p>
                                                        <p v-for="(sonitem,sonIndex) in item.answerList">
                                                        {{sonitem.content}}<span v-if="sonIndex !=item.answerList.length-1">，</span>
                                                    </p>
                                                    </div>
                                                </div>
                                                <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                                            </div>
                                                    </div>
                                                    <div class="ques-answers">
                                                        <div class="test_result">
                                                            <div class="rightAnswer flex">
                                                                <span v-if="item.type != 7 && item.type != 9 && item.type != 5">
                                                                    正确答案：
                                                                    <span v-for="(sonitem,sonIndex) in item.answerList">
                                                                     <strong  v-if="sonitem.isRight == 1">
                                                                        {{Eng[sonIndex]}}
                                                                    </strong>
                                                                    </span>
                                                                </span>
                                                                <span v-if="item.type == 5" class="flex align-cen" style="color:#009aff">
                                                                        参考答案：
                                                                        <span v-html="item.refAnswer"></span>
                                                                    </span>
                                                                        <span v-if="item.type == 7">
                                                                                正确顺序：
                                                                                <span v-for="(sonitem,sonIndex) in sortedIndexes">
                                                                                    <span>
                                                                                    {{Eng[sonitem]}}
                                                                                </span>
                                                                                </span>
                                                                            </span>
                                                            </div>
                                                              <div class="rightAnswer flex">
                                                                <span>
                                                                    分数：
                                                                   
                                                                     <strong >
                                                                        {{item.score}}
                                                                    </strong>
                                                                    
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                 </div>
                            </div>
                           </div>
                        </div>
                     </div>
                     <div v-else class="no-empry">
                        暂无数据
                     </div>
                 </div>
             </div>
        </div>
        </div>
           <!-- 打开题目编辑 -->
        <el-dialog
  title="编辑题目"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
  <div class="forminfo"> 
      <topicTemplate  
    :propData='propData'
    :propIndex="propIndex"
    ref="topicTemplate"
    @emitFun="handleData"
    ></topicTemplate>
    <div class="authbtn flex align-cen">
             <el-button plain  @click="centerDialogVisible = false">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit">确认</el-button>
        </div>
  </div>
        </el-dialog>
    </div>
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import topicTemplate from "@/views/testPaper/topicList/addTopic/index.vue"; //将题目列表页面作为组件使用
export default {
    name:'topicImport',
    components: {
        topicSteps,
        topicTemplate
    },
    props: {
    PropType:[String, Number],
  },
    data () {
        return {
            loading:false,
            propIndex:'',
            centerDialogVisible:false,
            importTopic:false,
            header:{},
            itemList:[],
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            sortedIndexes:[],
            propData:{},
            propList:[
            {
                steps:1,
                text:'上传模版',
            },
            {
                steps:2,
                text:'检查试题',
            },{
                steps:3,
                text:'系统检查',
            },{
                steps:4,
                text:'导入试题', 
            }

        ]
        }
    },
    created () {
       this.$bus.$off('importTopic')
        this.$bus.$on("importTopic", msg =>{   //vaPage传的时候的key是什么接收就必须是什么
            this.importTopic = msg
        })
        let token = this.$locaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
        // 导入进入下一步
        openTwoSteps(){
             const encryptQuery = this.$base64.encode(JSON.stringify(this.itemList)) //链接参数加密
                if(this.itemList.length){
                if(!this.PropType){
                    // 不是组件直接进入第二步
                    this.$router.push({name:'twoSteps',query:{data:encryptQuery,type:this.PropType}})
                }else{
                    // 为组件调用先触发父组件事件然后由父组件调用第二步(当作组件调用)
                this.$emit('sendStatus',encryptQuery)
                }
            }else{
             this.$util.Notifi(`无试题，请重新导入试题模版`,'error','fa-exclamation-circle') 
                     this.importTopic = false
            }
        },
        // 取消导入
        cacelIM(){
            this.importTopic = false
        },
        // 接收子组件传输数据
        handleData(data,index){
        // 创建新数组并插入新元素
        let newArr = this.itemList.slice(0,index).concat([data]).concat(this.itemList.slice(index + 1))
        this.itemList = newArr
        // 创建一个包含原数组索引和值的数组  
            let indexedArray = data.answerList.map((item, index) => ({ item, index }));  
            // 根据sort值进行排序  
            indexedArray.sort((a, b) => a.item.sort - b.item.sort);      
            // 提取排序后的索引  
            this.sortedIndexes = indexedArray.map(item => item.index);  
         this.centerDialogVisible = false 
        },
        onSubmit(){
              this.$refs.topicTemplate.emitData()  
        },
         // 删除试题
        deletTopic(index){
          this.$confirm('您确定要删除该试题吗？删除后会影响添加了该题的试卷，请您谨慎操作！?', '删除试题', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        let delet= this.itemList.filter((item,sy)=> sy != index) 
        this.itemList = delet
        })
        },
          // 编辑试题
        editTopic(propData,index){
            this.propData = propData
            this.propIndex = index
            this.centerDialogVisible = true
        },
        // 展开处理
        openTopicRe(isTrue,index,data){
            this.itemList[index].isTrue = !isTrue
             if(data.type == 7){
                    // 创建一个包含原数组索引和值的数组  
                        let indexedArray = data.answerList.map((item, index) => ({ item, index }));  
                        // 根据sort值进行排序  
                        indexedArray.sort((a, b) => a.item.sort - b.item.sort);      
                        // 提取排序后的索引  
                        this.sortedIndexes = indexedArray.map(item => item.index);  
                }
        },
        // 下载模版
        openExcel(){
            window.open(`${this.$config.baseUrl}/admin/statics/template/question.xlsx`,'_blank')
        },
        // 文件上传成功
        handleSuccess(res, file){
            this.itemList = []
           if(res.code == 0){
             if(res.data && res.data.length > 0){
                 let arr = res.data
              arr.forEach(e => {
                e['isTrue'] = false
              });
              this.itemList = arr
            this.importTopic = true
             }else{
           this.$util.Notifi(`上传模版有误，请检查`,'error','fa-exclamation-circle') 
             this.$refs.upload.clearFiles(); 
             }
           }else{
            this.$util.Notifi(`${res.msg}`,'error','fa-exclamation-circle') 
             this.$refs.upload.clearFiles();  
           }
        }
    },
    destroyed(){
        this.$bus.$off('importTopic')
    }
}
</script>
<style lang="scss" scoped>
.importTopic{
    width: 100%;
    text-align: center;
    padding-top: 100px;
    box-sizing: border-box;
    .template-text{
        display: flex;
        align-items: center;
    justify-content: center;
    color: #7a8c99;
    font-size: 14px;
    cursor: pointer;
    padding-top: 20px;
.excel-icon{
        display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../../../assets/images/excel-deactivate.svg') center no-repeat;
}
    }
    .tips-text{
   background-color: #f2f9fe;
    padding: 25px 10px 30px 30px;
    margin: 50px 35px 24px;
    text-align: left;
    .title{
        font-size: 18px;
        color: #36aafd;
    line-height: 30px;
    font-weight: normal;
    font-stretch: normal;
    }
    p{
        font-size: 16px;
        line-height: 30px;
    letter-spacing: 0px;
    color: #666666;
    }
    }
}
.public-list-container{
    position: relative;
    .public-list-container-table{
         .pustclass{
            width: 15%;
            text-align: center;
          }
          .stsort{
            width: 40% !important;
            text-align: center;
             overflow: hidden;
                    text-overflow: ellipsis;
                    white-space:nowrap
          }
        .public-list-container-table-row {
            padding: 30px 0 !important;
            .pdd{
                padding-bottom: 30px;
            }
           
        }
        .topicIstru{
                border-top: solid 1px #ccc;
                padding: 30px 10px;
            .duplicate-questions{
                
                .duplicate-question{
                    max-width: 50%;
                    flex: 1 1 50%;
                    padding-right: 15px;
                    padding-left: 15px;
                    margin-bottom: 10px;
                    box-sizing: border-box;
                    .portlet{
                        background: #fafafa;
                        padding: 16px 10px !important;
                        border-radius: 5px;
                        .portlet-head{
                            border-bottom: 0;
                            padding: 0 10px;
                            margin-bottom: 0;
                            color: #fff;
                            .caption{
                               font-size: 16px;
                                color: #333;
                                font-weight: 600;
                                padding: 11px 0 9px 0;
                            }
                            .btn-set{
                                .btn-blue-delete{
                                    font-size: 13px;
                                    line-height: 1.5;
                                    cursor: pointer;
                                    color: #36aafd;
                                    border: 1px solid #36aafd;
                                    padding: 8px 25px !important;
                                    border-radius: 4px !important;
                                    box-sizing: border-box;
                                    margin-right: 5px;
                                }
                                .btn-default{
                                    font-size: 13px;
                                    line-height: 1.5;
                                    cursor: pointer;
                                    color: #fff;
                                    background-color: #36aafd;
                                    padding: 8px 25px !important;
                                    border: 1px solid #36aafd;
                                    border-radius: 4px !important;
                                }
                            }
                        }
                        .portlet-body{
                            padding: 10px;
                            .duplication-info-container{
                                .ques-title {
                                    position: relative;
                                    padding-right: 50px;
                                    font-size: 17px;
                                    vertical-align: middle;
                                    line-height: 1.5;
                                    -webkit-margin-before: 0;
                                    -webkit-margin-after: 0;
                                    word-break: break-word;
                                    .ques-type{
                                      background-color: #387dfe;
                                        color: #fff;
                                        padding: 3px 12px;
                                        border: none;
                                        font-size: 12px;
                                        width: 75px;
                                        text-align: center;
                                    }
                                    .qcotent{
                                        padding: 0 10px;
                                        font-size: 15px;
                                    }
                                    .ques-score{
                                        position: absolute;
                                        top: 0px;
                                        right: 10px;
                                        color: #000;
                                    }
                                }
                                .question-option-list{
                                    padding: 0 20px;
                                    margin-top: 10px;
                                    li{
                                        list-style-type: upper-latin;
                                        margin-bottom: 15px;
                                        font-size: 14px;
                                    }
                                    li::marker{
                                       unicode-bidi: isolate;
                                    font-variant-numeric: tabular-nums;
                                    text-transform: none;
                                    text-indent: 0px !important;
                                    text-align: start !important;
                                    text-align-last: start !important; 
                                    }
                                }
                                .ques-answers{
                                    .test_result{
                                        margin-bottom: 8px;
                                       .rightAnswer{
                                            color: #36aafd;
                                            display: block;
                                            font-size: 16px;
                                       } 
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
::v-deep{
    .el-dialog{
        margin-top: 5vh !important;
    }
    .el-upload-dragger{
    background: none;
    border: none;
    height: auto;
   .icon-al-file-fill{
    font-size: 80px;
    color: #C0C4CC;
    margin: 40px 0 16px;
    }
    .el-button{
        margin-top: 30px;
    }
    }
    
 
}
</style>